import { Autocomplete } from "@mui/material";
import { IGAutoCompleteProps, IAutocompleteProps, getLabel, isSelect } from "./GTextSelect";
import { IGWidget, appendClass } from "../GWidget";
import { ISelectRow } from "../dropdown/Dropdown"
import { useEffect, useState } from "react";
import GTextField from "./GTextField";
import _ from "lodash";
import { useValidator } from "../form/Validators";

export interface IGTextSelectFreeProps extends IAutocompleteProps<string,true>, IGWidget, Omit<IGAutoCompleteProps<string>,"value"|"defaultValue"> {
    value?:string;
    defaultValue?:string|ISelectRow<string>
    floatLabel?:string
    onChange?:(e:any, selected:ISelectRow<string>|null, text:string)=>void
    canClear?:boolean
}

function getSelect(selected:ISelectRow<string>|string|null|undefined) : ISelectRow<string>|null {
    if (isSelect(selected)) return selected 
    else return null
}

export default function GTextSelectFree(props:IGTextSelectFreeProps){
    const {onChange,floatLabel,placeholder,textProps,value,id,className,canClear,form,controlName,...acProps} = props
    const [textValue,setTextValue] = useState<string>(value || "")
    const {control,error} = useValidator(props)
    const _onSelect = (e:any,value:ISelectRow<string>|string|null) => {
        const selected = getSelect(value)
        control?.update(selected)
        form?.setDirty(true)
        onChange?.(e, selected, selected ? selected.value : (value as string|null)||"")
    }
    const _onChange = (e:any,value:string,reason:string) => {
        if (reason=="input") onChange?.(e, null, value)
        setTextValue(value)
        control?.update(value)
        form?.setDirty(true)
    }
    const onClose = (_:any,reason:string) => {
        if (reason=="selectOption") return
        control?.setDirty(true, true)
        form?.setDirty(true)
    }
    const getOptionLabel = (option : ISelectRow<string>|string) => isSelect(option) ? option.label : option
    const _isEqual = (option:ISelectRow<string>|string, value:ISelectRow<string>|string) => {
        if (isSelect(option) && isSelect(value)) return option.value===value.value
        else if (isSelect(value)) return option===value.value
        else if (isSelect(option)) return option.value===value
        else return option===value
    }
    useEffect(() => {
        const text = props.value || ""
        if (text != textValue) setTextValue(text)
    }, [props.value])
    const inputProps : Record<string,any> = {}
    if (error) {
        inputProps.error = true
        inputProps.helperText = error
    }
    return <Autocomplete className={appendClass(canClear?"":"no-clear", className)} options={acProps.options} value={value} 
        onChange={_onSelect} onInputChange={_onChange} onClose={onClose} freeSolo={true}
        getOptionLabel={getOptionLabel} isOptionEqualToValue={_isEqual} inputValue={textValue}
        renderInput={
            (params) => <GTextField {...params} {...textProps} {...inputProps} value={textValue} id={id} 
            floatLabel={floatLabel} placeholder={placeholder}/>
        }/>
}